"use client";
import { jsx } from "react/jsx-runtime";
import { useEffect } from "react";
import { cn } from "../utils.js";
import { useDropdownContext } from "./context.js";
import { DropdownBaseItem } from "./DropdownBaseItem.js";
import { DropdownBaseList } from "./DropdownBaseList.js";
const DropdownTextList = ({ items, className, classNameBase, selected, ...itemProps })=>{
    const { values, setItems } = useDropdownContext();
    useEffect(()=>{
        setItems(items.map((item)=>({
                ...item,
                type: 'text'
            })));
    }, [
        items
    ]);
    return /*#__PURE__*/ jsx(DropdownBaseList, {
        selected: selected,
        className: classNameBase,
        children: items.map((item)=>{
            const isSelected = values.includes(item.value);
            return /*#__PURE__*/ jsx(DropdownBaseItem, {
                value: item.value,
                searchKey: item.label,
                isSelected: isSelected,
                disabled: item.disabled,
                className: cn(isSelected && 'tw-bg-neutral-light-300 dark:tw-bg-neutral-dark-600', className),
                ...itemProps,
                children: item.label
            }, item.value);
        })
    });
};
export { DropdownTextList };
